import { Component, OnInit } from '@angular/core';
import { TermpageService } from './termpage.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { PosthogService } from 'src/app/shared/services/posthog.service';
import { TermsOfServiceContentComponent } from './terms-of-service-content/terms-of-service-content.component';
import { TermsOfServiceSupportComponent } from './terms-of-service-support/terms-of-service-support.component';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss'],
  imports: [TermsOfServiceContentComponent, TermsOfServiceSupportComponent],
})
export class TermsOfServiceComponent implements OnInit {
  pageData:any;
  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  constructor(
    private termpageService: TermpageService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router,
    private posthogService: PosthogService
  ) {
    this.getUrl = this.router.url;
  }

  ngOnInit(): void {
    this.termpageService.gettermPageData();
    this.pageData = this.route.snapshot.data?.['seo']?.[0]?.fields;
    this.meta.updateMeta(
      this.route.snapshot.data?.['seo']?.[0]?.fields?.seoMetadataReference
        ?.fields
    );
    this.canonical.setCanonicalURL();
    let data = this.route.snapshot.data?.['seo']?.[0]?.fields;
    this.metaBody.title = data?.seoMetadataReference?.fields?.title || 'Verto: Cross-border payments platform for businesses';
    this.metaBody.description = data?.seoMetadataReference?.fields?.description || 'Verto: Cross-border payments platform for businesses across the globe.';
    this.metaBody.type = 'Terms of Service';
    this.metaBody.url = this.getUrl;
    this.metaBody.image = '';
    this.meta.updateOG(this.metaBody);

    this.posthogService.capturePageViewEvent('terms_of_service');
  }
}
